import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import API from "../../../utils/axios";
import BlackButton from "../BlackButton";
import { useSnackbar } from "notistack";
import Form from "../../common/Form";

export default function AuthTab({
  userData,
  setLoading,
  saveDisabled,
  setSaveDisabled
}) {
  const [inputValues, setInputValues] = useState({
    password: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [errorValues, setErrors] = useState({});

  const handleChange = e => {
    setInputValues({ ...inputValues, [e.target.name]: e.target.value });
    setSaveDisabled(false);
  };

  useEffect(() => {
    setInputValues({
      password: "",
      newPassword: "",
      confirmPassword: ""
    });
  }, []);

  const { enqueueSnackbar } = useSnackbar();

  const checkForErrors = () => {
    const newErrors = {
      password: inputValues.password.length ? "" : "Please fill in this field",
      newPassword: inputValues.newPassword.length
        ? inputValues.newPassword.length >= 6
          ? inputValues.newPassword === inputValues.password
            ? "New and current passwords must be different"
            : ""
          : "Use 6 characters or more"
        : "Please fill in this field",
      confirmPassword: inputValues.confirmPassword.length
        ? inputValues.newPassword === inputValues.confirmPassword
          ? ""
          : "Passwords do not match"
        : "Please fill in this field"
    };

    setErrors(newErrors);

    return Object.values(newErrors).some(val => val);
  };

  const handleSave = e => {
    e.preventDefault();

    if (checkForErrors()) return;

    setLoading(true);
    API.patch(`v1/users/${userData.id}/password`, {
      new_password: inputValues.newPassword,
      current_password: inputValues.password
    })
      .then(res => {
        setInputValues({ password: "", newPassword: "", confirmPassword: "" });
        enqueueSnackbar("Password successfully updated");
      })
      .catch(e => {
        if (e.data && e.data.message === "Incorrect password") {
          setErrors({ password: "Wrong password" });
        }
      })
      .finally(() => {
        setSaveDisabled(true);
        setLoading(false);
      });
  };

  return (
    <Box
      pt={3}
      display="flex"
      flexDirection="column"
      height="100%"
      style={{ boxSizing: "border-box" }}
    >
      {/* Form */}
      <Form
        data={[
          [
            {
              renderInputField: true,
              label: "Current password",
              name: "password",
              type: "password",
              dataCy: "password"
            }
          ],
          [
            {
              renderInputField: true,
              label: "New password",
              name: "newPassword",
              type: "password",
              dataCy: "newPassword"
            }
          ],
          [
            {
              renderInputField: true,
              label: "Confirm new password",
              name: "confirmPassword",
              type: "password",
              dataCy: "confirmPassword"
            }
          ]
        ]}
        handleChange={handleChange}
        inputValues={inputValues}
        errorValues={errorValues}
      />

      {/* Cancel / Update */}
      <Box display="flex" justifyContent="flex-end" py={1} mt={3}>
        <BlackButton
          handleClick={handleSave}
          disabled={saveDisabled}
          content="Save"
          data-cy="Save"
        />
      </Box>
    </Box>
  );
}
